<template>
    <div>
        <CompassButton
            :label="$t.__('common.actions.verify')"
            type="tertiary"
            :disabled="disableVerify"
            @click="goToVerif"
            v-if="canVerifOcr"
        />
        <CompassButton
            :label="$t.__('common.actions.delete')"
            type="tertiary-destructive"
            @click="deleteFile"
            v-if="canVerifOcr"
        />
    </div>
</template>

<script>
import { goToUrl } from '../../helpers';
import Ocr from 'api/ocr';

export default {
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        canVerifOcr: {
            type: Boolean,
            required: true,
        },
        listinghash: {
            type: String,
            required: true,
        },
    },
    methods: {
        goToUrl,
        goToVerif() {
            this.goToUrl(
                this.$router.resolve({ name: 'ocr.verification.form', params: { id: this.id } })
                    .href,
            );
        },
        deleteFile() {
            Ocr.deleteOcr(this.id).then((response) => {
                EventBus.emit('listing:refresh');
            });
        },
    },
    computed: {
        disableVerify() {
            return ['processing', 'pending'].includes(
                this.$store.state[this.listinghash].rows.find((row) => row.id === this.id)?.state,
            );
        },
    },
};
</script>
